import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;

    const onStatusAdded = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, statuses: [...(prevState.statuses || []), selectedOption.id] }
        })
    }

    const onStatusRemove = (removedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, statuses: prevState.statuses.filter((id) => id !== removedOption.id) }
        })
    }
    
    const onOwnerTypeAdded = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, owner_type: [...(prevState.owner_type || []), selectedOption.id] }
        })
    }

    const onOwnerTypeRemove = (removedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, owner_type: prevState.owner_type.filter((id) => id !== removedOption.id) }
        })
    }

    const onSchemeSelect = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, scheme_id: [...(prevState.scheme_id || []), selectedOption.id] }
        })
    }

    const onSchemeRemove = (removedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, scheme_id: prevState.scheme_id.filter((id) => id !== removedOption.id) }
        })
    }

    const onModelSelect = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, model_id: [...(prevState.model_id || []), selectedOption.id] }
        })
    }

    const onModelRemove = (removedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, model_id: prevState.model_id.filter((id) => id !== removedOption.id) }
        })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
            <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <MultiSelectField
                    options={[
                        {
                            id: 'active',
                            name: 'Active'
                        },
                        {
                            id: 'blocked',
                            name: 'Blocked'
                        },
                        {
                            id: 'defective',
                            name: 'Defective'
                        },
                        {
                            id: 'damaged',
                            name: 'Damaged'
                        },
                        {
                            id: 'deleted_by_sap',
                            name: 'Deleted By SAP'
                        },
                    ]}
                    fieldName="statuses"
                    stateModel={filtersModel}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onStatusAdded}
                    onRemove={onStatusRemove}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Owner Type</Form.Label>
                <MultiSelectField
                    options={[
                        {
                            id: 'ServiceCenter',
                            name: 'Service Center'
                        },
                        {
                            id: 'CsWareHouse',
                            name: 'CS Warehouse'
                        },
                        {
                            id: 'User',
                            name: 'User'
                        },
                    ]}
                    fieldName="owner_type"
                    stateModel={filtersModel}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onOwnerTypeAdded}
                    onRemove={onOwnerTypeRemove}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Model</Form.Label>
                <MultiSelectField
                    options={[]}
                    fieldName="model_id"
                    stateModel={filtersModel}
                    dynamicOptions={{
                        dependsOnFields: [],
                        apiName: "batteryModels",
                        dataAttr: "battery_models",
                    }}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onModelSelect}
                    onRemove={onModelRemove}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Scheme</Form.Label>
                <MultiSelectField
                    options={[]}
                    fieldName="scheme_id"
                    stateModel={filtersModel}
                    dynamicOptions={{
                        dependsOnFields: [],
                        apiName: "schemes",
                        dataAttr: "schemes",
                    }}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onSchemeSelect}
                    onRemove={onSchemeRemove}
                />
            </Form.Group>
        </div>
    </Filters>
};

export default FiltersPartial;
